import {postAuthorization} from '../api/postAuthorization';
import {setAuthorizeAction} from '../action';

const setPostAuthorization = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await postAuthorization(params);

            if (data.status === 'success') {
                localStorage.setItem('token', data.token);
                dispatch(setAuthorizeAction(true))
                window.location.replace(window.location.origin);
            }
          
        } catch(error) {
            // window.location.replace('https://win777.fun');
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostAuthorization
}